import { styled } from '@mui/material/styles';

import type { DocumentStatusVariant } from '@/pages/document/DocumentViewer/DocumentFileView/PageView/components/DocumentStatusBadge/types';

export const BadgeRoot = styled('div', {
  label: 'DocumentStatusBadge',
  shouldForwardProp: (propName) => propName !== 'variant',
})<{ variant: DocumentStatusVariant }>(({ theme, variant }) => {
  const palette = variant === 'paid' ? theme.palette.secondary : theme.palette.primary;

  return {
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(0.75, 5),
    borderRadius: theme.spacing(1, 1, 0, 0),
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
    lineHeight: 1.4,
    whiteSpace: 'nowrap',
    color: theme.palette.common.white,
    backgroundColor: palette.main,
  };
});
